import React from "react";
import { pdf } from "@react-pdf/renderer";

import { ReportPdf } from "./helpers/ReportPdf";
import Logo_Constructora from "../../assets/logo-constructora-white.svg";
import Logo_Proyecto from "../../assets/logo_proyecto-white.svg";
import Icon_Exit from "../../assets/icons/button_exit.svg";
import BrowserInfo from '../components/helpers/BrowserInfo';

interface Props {
  propertyType: any;
  isPortrait: boolean,
  showQuote: boolean,
  totalPrice: string,
  selectedElements: any,
  bookingURL: string,
  bookingParams: any,
  setShowQuote: (value: boolean) => void;
}

const Intro: React.FC<Props> = ({ isPortrait, propertyType, showQuote, totalPrice, selectedElements, bookingURL, bookingParams, setShowQuote }) => {

  const browserInfo = BrowserInfo();
  const [showForm, setShowForm] = React.useState(false);
  const [sendingForm, setSendingForm] = React.useState(false);

  const fullName = React.useRef("");
  const idType = React.useRef("CC");
  const id = React.useRef("");
  const email = React.useRef("");
  const phone = React.useRef("");

  const [fullNameError, setFullNameError] = React.useState(true);
  const [idError, setIdError] = React.useState(true);
  const [emailError, setEmailError] = React.useState(true);
  const [phoneError, setPhoneError] = React.useState(true);
  const [formError, setFormError] = React.useState(true);

  React.useEffect(() => {
    setFormError(fullNameError || idError || emailError || phoneError);
  }, [fullNameError, idError, emailError, phoneError]);


  const Currency = (value: string) => {
    const number = PriceToNumber(value);
    return NumberToPrice(number);
  }
  const PriceToNumber = (price: string) => {
    if (!price)
      return 0;
    const number = Number(price.replace(/,/g, ''));
    return number ? number : 0;
  };
  const NumberToPrice = (price: number) => {
    const formatted = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(price) + " cop";
    return formatted;
  };

  const SetFullName = (value: string) => {
    fullName.current = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    setFullNameError(value.length < 10);
  };
  const SetIdType = (value: string) => {
    idType.current = value;
  };
  const SetId = (value: string) => {
    id.current = value;
    setIdError(value.length < 8);
  };
  const SetEmail = (value: string) => {
    email.current = value;
    setEmailError(!value.includes("@") || !value.includes(".") || value.length < 6);
  };
  const SetPhone = (value: string) => {
    phone.current = value;
    setPhoneError(!value.startsWith("3") || value.length < 10)
  };

  const SendUserDataForm = async () => {
    console.log("enviando correo....")
    setSendingForm(true);

    const blob = await pdf(<ReportPdf data={selectedElements} total={totalPrice}/>).toBlob();
    const pdfBase64 = await BlobToBase64(blob);

    const payload: any = {
      fullName: fullName.current,
      idType: idType.current,
      id: id.current,
      email: email.current,
      phone: phone.current,
      pdfFilename: "cotizacion.pdf",
      pdfBase64 : pdfBase64,
    };

    const resp = await fetch("https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/decosim/equilatero", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await resp.json();
    if (!resp.ok) {
      const errMsg = "error" in data ? data.error : "Error enviando correo";
      console.error(errMsg)
    }

    setSendingForm(false);
    setShowQuote(false);
    setShowForm(false);
    ResetValues();
  }

  const BlobToBase64 = (blob: Blob): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("No se pudo convertir el archivo a base64"));
        return;
      }
      // result: "data:application/pdf;base64,JVBERi0x..."
      const base64 = result.split(",")[1] ?? "";
      if (!base64) {
        reject(new Error("Base64 vacío"));
        return;
      }
      resolve(base64);
    };

    reader.onerror = () => reject(reader.error ?? new Error("Error leyendo el archivo"));
    reader.readAsDataURL(blob);
  });


  // const DownloadPDF = async () => {
  //   try {
  //     const blob = await pdf(<ReportPdf data={selectedElements} total={totalPrice}/>).toBlob();

  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "cotizacion.pdf"; // nombre del archivo
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     URL.revokeObjectURL(url);
  //   } finally {
  //   }
  // }

  const ResetValues = () => {
    fullName.current = "";
    idType.current = "CC";
    id.current = "";
    email.current = "";
    phone.current = "";
    setFullNameError(true);
    setIdError(true);
    setEmailError(true);
    setPhoneError(true);
  }

  const Cotizar = () => {
    setShowForm(true);
    //DownloadPDF();
  }

  // const OpenURL = (url: string) => {
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  const OpenPost = (url: string, params: any) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.target = "_blank";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "unit_config";
    input.value = JSON.stringify(params);
    console.warn(`%cValor Parámetro 'unit_config' enviado por POST:\n${input.value}`, "color: red");
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  return (
    <div className={`tour-full-quote ${showQuote === true ? '' : 'hide'} ${isPortrait === true ? 'portrait' : ''}`}>
      <div className={`tour-quote-container1 ${isPortrait ? 'portrait' : ''}`}>
        <div className={`tour-quote-container2 ${isPortrait ? 'portrait' : ''}`}>



          {!showForm ?
            <div className={`tour-quote ${isPortrait ? 'portrait' : ''}`}>

              <div className={`tour-quote-container-logos ${isPortrait ? 'portrait' : ''}`}>
                <img className={`tour-quote-logo`} src={Logo_Constructora} draggable={false} alt='' />
                <div className={`tour-quote-space1 ${isPortrait ? 'portrait' : ''}`} />
                <img className={`tour-quote-logo`} src={Logo_Proyecto} draggable={false} alt='' />
              </div>

              <div className={`tour-quote-title ${isPortrait ? 'portrait' : ''}`}>Resumen de cotización</div>
              <div className={`tour-quote-subtitle ${isPortrait ? 'portrait' : ''}`}>{propertyType.quote_text}</div>

              <div className={`tour-quote-data ${isPortrait ? 'portrait' : ''}`}>
                {
                  selectedElements.map((element: any, index: number) =>
                    <div key={`quote_item_${index}`} className={`tour-quote-item ${(index % 2 === 1) ? 'even' : ''} ${isPortrait ? 'portrait' : ''}`}>
                      <div className={`tour-quote-item-title ${isPortrait ? 'portrait' : ''}`}>{element.quote_text}</div>
                      <div className={`tour-quote-item-value ${isPortrait ? 'portrait' : ''}`}>{Currency(element.price)}</div>
                    </div>
                  )
                }
              </div>

              <div className={`tour-quote-border ${isPortrait ? 'portrait' : ''}`} />

              <div className={`tour-quote-total ${isPortrait ? 'portrait' : ''}`}>
                <div className={`tour-quote-total-title ${isPortrait ? 'portrait' : ''}`}>TOTAL</div>
                <div className={`tour-quote-total-value ${isPortrait ? 'portrait' : ''}`}>{totalPrice}</div>
              </div>

              <div className={`tour-quote-button ${isPortrait ? 'portrait' : ''}`} onClick={() => Cotizar()}>
                <div className={`tour-quote-button-text ${isPortrait ? 'portrait' : ''}`}>¡Quiero cotizar!</div>
              </div>

            </div>
            :
            <div className={`tour-quote-form-container ${isPortrait ? 'portrait' : ''}`}>

              <div className={`tour-quote-container-logos ${isPortrait ? 'portrait' : ''}`}>
                <img className={`tour-quote-logo`} src={Logo_Constructora} draggable={false} alt='' />
                <div className={`tour-quote-space1 ${isPortrait ? 'portrait' : ''}`} />
                <img className={`tour-quote-logo`} src={Logo_Proyecto} draggable={false} alt='' />
              </div>

              <div className={`tour-quote-form-title ${isPortrait ? 'portrait' : ''}`}>Para continuar ingresa tus datos</div>
              <div className={`tour-quote-form-subtitle ${isPortrait ? 'portrait' : ''}`}>Tomará solo un momento y nos permitirá enviarte una copia de la cotización que realizaste.</div>

              <div className={`tour-quote-form ${isPortrait ? 'portrait' : ''}`}>
                <div className={`tour-quote-form-block ${isPortrait ? 'portrait' : ''}`}>
                  <div className={`tour-quote-form-block-title ${fullNameError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`}>Nombre y apellidos</div>
                  <input className={`tour-quote-form-block-input ${fullNameError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`} type='text' onChange={(e: any) => { SetFullName(e.target.value) }} />
                </div>
                <div className={`tour-quote-form-block ${isPortrait ? 'portrait' : ''}`}>
                  <div className={`tour-quote-form-block-title ${idError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`}>Documento de identidad</div>
                  <div className={`tour-quote-form-block-dual ${isPortrait ? 'portrait' : ''}`}>
                    <select className={`tour-quote-form-block-selection ${isPortrait ? 'portrait' : ''}`} onChange={(e: any) => { SetIdType(e.target.value) }}>
                      <option value={"CC"}>CC</option>
                      <option value={"CE"}>CE</option>
                    </select>
                    <input className={`tour-quote-form-block-input small ${idError ? 'error' : ''}`} type='number' onChange={(e: any) => { SetId(e.target.value) }} />
                  </div>
                </div>
              </div>
              <div className={`tour-quote-form ${isPortrait ? 'portrait' : ''}`}>
                <div className={`tour-quote-form-block ${isPortrait ? 'portrait' : ''}`}>
                  <div className={`tour-quote-form-block-title ${emailError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`}>Correo electrónico</div>
                  <input className={`tour-quote-form-block-input ${emailError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`} type='text' onChange={(e: any) => { SetEmail(e.target.value) }} />
                </div>
                <div className={`tour-quote-form-block ${isPortrait ? 'portrait' : ''}`}>
                  <div className={`tour-quote-form-block-title ${phoneError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`}>Número de contacto</div>
                  <input className={`tour-quote-form-block-input ${phoneError ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`} type='number' onChange={(e: any) => { SetPhone(e.target.value) }} />
                </div>
              </div>


              <div className={`tour-quote-form-button ${formError || sendingForm ? 'error' : ''} ${isPortrait ? 'portrait' : ''}`} onClick={() => { if(!formError && !sendingForm){SendUserDataForm();} }}>
                <div className={`tour-quote-form-button-text ${isPortrait ? 'portrait' : ''}`}>{sendingForm ? "...Enviando..." : "Enviar cotización"}</div>
              </div>
              {browserInfo.urlParams.get("showBooking") === 'true' && <div className={`tour-quote-form-button ${isPortrait ? 'portrait' : ''}`} onClick={() => { OpenPost(bookingURL, bookingParams) }}>
                <div className={`tour-quote-form-button-text ${isPortrait ? 'portrait' : ''}`}>Pagar Reserva</div>
              </div>}
              <div className={`tour-quote-form-disclosure ${isPortrait ? 'portrait' : ''}`}>Al presionar el botón "Enviar" estoy aceptando la política de tratamientos de datos y consultas SAGRILAFT.</div>

            </div>
          }


          <img className={`tour-quote-button-close ${isPortrait ? 'portrait' : ''}`} src={Icon_Exit} alt='' onClick={() => { setShowQuote(false); setShowForm(false); }} />
        </div>
      </div>
    </div>
  );
};

export default Intro;
